import React from 'react'
import { Route } from 'react-router-dom'
import AlteracaoCentroCusto from './correcoes/AlteracaoCentroCusto'
import SwitchRouter from 'components/SwitchRouter'

export default function Routes({ match: { path } }) {
    const routes = [
        { path: `${path}/correcoes/alteracao-centro-de-custo`, component: AlteracaoCentroCusto }
    ]
    return (
        <SwitchRouter>
            {routes.map((props, i) => <Route key={i} {...props} />)}
        </SwitchRouter>
    )
}
